var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #aab2b7;\n        stroke: #aab2b7;\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_White_Comment",
    "data-name": "Icon White Comment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bounds",
    className: "cls-1",
    d: "m0,0h40v40H0V0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fast-forward-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "m19.81,27.8c-.08,0-.16-.02-.22-.07l-10.42-7.41c-.18-.13-.22-.37-.09-.55.02-.03.06-.07.09-.09l10.42-7.42c.06-.05.14-.07.22-.07.06,0,.12.02.18.04.13.07.21.2.21.35v6.94l10.2-7.25c.17-.12.41-.08.54.09.05.07.07.15.07.24v14.82c0,.15-.08.28-.21.35-.13.07-.28.06-.4-.03l-10.2-7.25v6.94c0,.21-.17.39-.39.39h0,0Zm-.39-14.47l-9.37,6.67,9.37,6.66v-13.33h0Zm10.81,0l-9.36,6.67,9.36,6.66v-13.33h0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.6d785c14fb10f50c31aacd9196974f44.svg";
export { ForwardRef as ReactComponent };